<template>
  <div>
    <div class="field is-grouped is-grouped-multiline">
      <p v-for="option in presets" :key="option.value" class="control">
        <button
          :class="['button', 'is-small', preset === option.value && 'is-link']"
          type="button"
          @click="$emit('preset', option.value)"
        >
          {{ option.label }}
        </button>
      </p>
    </div>

    <div class="columns is-multiline" style="margin-top: 0.5rem">
      <div class="column is-half">
        <label class="label">Από</label>
        <DatePicker
          :value="from"
          :clearable="false"
          :disabled-date="isAfterToday"
          type="date"
          value-type="format"
          format="YYYY-MM-DD"
          placeholder="Επιλέξτε ημ/νία έναρξης"
          style="width: 100%"
          @input="$emit('update:from', $event)"
          @change="$emit('preset', 'custom')"
        />
      </div>
      <div class="column is-half">
        <label class="label">Έως</label>
        <DatePicker
          :value="to"
          :clearable="false"
          :disabled-date="isAfterToday"
          type="date"
          value-type="format"
          format="YYYY-MM-DD"
          placeholder="Επιλέξτε ημ/νία λήξης"
          style="width: 100%"
          @input="$emit('update:to', $event)"
          @change="$emit('preset', 'custom')"
        />
      </div>
    </div>

    <p v-if="validationError" class="help is-danger">
      {{ validationError }}
    </p>
    <p v-else-if="rangeInDaysLabel" class="help has-text-grey">
      Επιλεγμένο διάστημα: <strong>{{ rangeInDaysLabel }}</strong>
    </p>
  </div>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/el';

export default {
  components: { DatePicker },

  props: {
    from: { type: String, default: null },
    to: { type: String, default: null },
    preset: { type: String, default: null },
    validationError: { type: String, default: null },
    rangeInDaysLabel: { type: String, default: '' },
  },

  data() {
    return {
      presets: [
        { value: 'currentMonth', label: 'Τρέχων μήνας' },
        { value: 'previousMonth', label: 'Προηγούμενος μήνας' },
        { value: 'last30Days', label: 'Τελευταίες 30 ημέρες' },
        { value: 'currentQuarter', label: 'Τρέχον τρίμηνο' },
        { value: 'previousQuarter', label: 'Προηγούμενο τρίμηνο' },
      ],
    };
  },

  methods: {
    isAfterToday(date) {
      return moment(date)
        .startOf('day')
        .isAfter(moment().startOf('day'));
    },
  },
};
</script>

<style scoped>
.field.is-grouped-multiline {
  margin-bottom: 0.5rem;
}
</style>
